var MIXPANEL_EVENTS = {
  OPEN_PATIENT_CARD: "OPEN_PATIENT_CARD",
  PATIENT_MERGE: "PATIENT_MERGE",
  MESSAGE_SENT: "MESSAGE_SENT",
  SUBMIT_ADD_PATIENT: "SUBMIT_ADD_PATIENT",
  SUBMIT_EDIT_PATIENT: "SUBMIT_EDIT_PATIENT",
  OPEN_ADD_PATIENT: "OPEN_ADD_PATIENT",
  OPEN_EDIT_PATIENT: "OPEN_EDIT_PATIENT",
  FILE_UPLOAD: "FILE_UPLOAD",
  ATTACHMENTS_POPOVER_OPENED: "ATTACHMENTS_POPOVER_OPENED",
  FORM_SUBMITTED: "FORM_SUBMITTED",
  FORM_OPENED: "FORM_OPENED",
  FORM_CLOSED: "FORM_CLOSED",
  FORM_SELECTOR_OPENED: "FORM_SELECTOR_OPENED",
  AUDIO_UPLOAD: "AUDIO_UPLOAD",
  ACTIVATE_CODE_STROKE: "ACTIVATE_CODE_STROKE",
  DEACTIVATE_CODE_STROKE: "DEACTIVATE_CODE_STROKE",
  UPDATE_CODE_STROKE: "UPDATE_CODE_STROKE",
  LKW_ADDED: "LKW_ADDED",
  LKW_CALCULATOR_OPEN: "LKW_CALCULATOR_OPEN",
  LKW_CALCULATOR_SAVED: "LKW_CALCULATOR_SAVED",
  PATIENT_SHARE_OPEN: "PATIENT_SHARE_OPEN",
  PATIENT_SHARED: "PATIENT_SHARED",
  REPORT_UPDATED: "REPORT_UPDATED",
  VIEWER_TOOLBAR_SELECTED: "VIEWER_TOOLBAR_SELECTED",
  STRUCTURED_RESPONSE_CALL_PATIENT: "STRUCTURED_RESPONSE_CALL_PATIENT",
  STRUCTURED_RESPONSE_CLICK: "STRUCTURED_RESPONSE_CLICK",
  SERIES_CLICKED: "SERIES_CLICKED",
  SERIES_LOADED: "SERIES_LOADED",
  SERIES_UNLOADED: "SERIES_UNLOADED",
  SIDEBAR_SERIES_CLICKED: "SIDEBAR_SERIES_CLICKED",
  FILTER_APPLIED: "FILTER_APPLIED",
  FILTER_SAVED: "FILTER_SAVED",
  FILTER_UPDATED: "FILTER_UPDATED",
  FILTER_DELETED: "FILTER_DELETED",
  PATIENT_SEARCH: "PATIENT_SEARCH",
  FULL_WIDTH_WORKLIST_OPENED: "FULL_WIDTH_WORKLIST_OPENED",
  FULL_WIDTH_WORKLIST_CLOSED: "FULL_WIDTH_WORKLIST_CLOSED",
  OPEN_SETTINGS: "OPEN_SETTINGS",
  UPLOAD_CSV: "UPLOAD_CSV",
  UPDATE_NOTIFICATION_SETTINGS: "UPDATE_NOTIFICATION_SETTINGS",
  UPDATE_WORKLIST_TAGS_SETTINGS: "UPDATE_WORKLIST_TAGS_SETTINGS",
  UPDATE_FORM_SETTINGS: "UPDATE_FORM_SETTINGS",
  UPDATE_AUTOMATED_SHARING_SETTINGS: "UPDATE_AUTOMATED_SHARING_SETTINGS",
  DELETE_AUTOMATED_SHARING_SETTINGS: "DELETE_AUTOMATED_SHARING_SETTINGS",
  CREATE_USER_GROUP: "CREATE_USER_GROUP",
  UPDATE_USER_GROUP: "UPDATE_USER_GROUP",
  LEAVE_USER_GROUP: "LEAVE_USER_GROUP",
  DELETE_USER_GROUP: "DELETE_USER_GROUP",
  ADD_USER_TO_GROUP: "ADD_USER_TO_GROUP",
  REMOVE_USER_FROM_GROUP: "REMOVE_USER_FROM_GROUP",
  UPDATE_WORKSPACE_MANAGEMENT_SETTINGS: "UPDATE_WORKSPACE_MANAGEMENT_SETTINGS",
  ADD_WORKSPACE_MANAGEMENT_SETTINGS: "ADD_WORKSPACE_MANAGEMENT_SETTINGS",
  MAKE_WORKSPACE_DEFAULT: "MAKE_WORKSPACE_DEFAULT",
  SHOW_HIDE_WORKSPACE_PATIENTS: "SHOW_HIDE_WORKSPACE_PATIENTS",
  EXIT_WORKSPACE: "EXIT_WORKSPACE",
  UPDATE_REPORT_TEMPLATES_SETTINGS: "UPDATE_REPORT_TEMPLATES_SETTINGS",
  ADD_REPORT_TEMPLATES_SETTINGS: "ADD_REPORT_TEMPLATES_SETTINGS",
  DELETE_REPORT_TEMPLATES_SETTINGS: "DELETE_REPORT_TEMPLATES_SETTINGS",
  OPEN_REPORT_TEMPLATE_SIGNATURE: "OPEN_REPORT_TEMPLATE_SIGNATURE",
  OPEN_CREATE_REPORT_TEMPLATE: "OPEN_CREATE_REPORT_TEMPLATE",
  OPEN_EDIT_REPORT_TEMPLATE: "OPEN_EDIT_REPORT_TEMPLATE",
  UPDATE_FORMATTING_SETTINGS: "UPDATE_FORMATTING_SETTINGS",
  EXPORT_DATA_SETTINGS: "EXPORT_DATA_SETTINGS",
  EXPORT_NEW_DATA_SETTINGS: "EXPORT_NEW_DATA_SETTINGS",
  OPEN_MERGE_PATIENT: "OPEN_MERGE_PATIENT",
  ADD_SCANS_FOR_PATIENT: "ADD_SCANS_FOR_PATIENT",
  OPEN_TERMS_OF_USE: "OPEN_TERMS_OF_USE",
  USER_LOGGEDOUT: "USER_LOGGEDOUT",
  OTP_LOGIN_SUCCESS: "OTP_LOGIN_SUCCESS",
  DASHBOARD_OPENED: "DASHBOARD_OPENED",
  DASHBOARD_LOADED: "DASHBOARD_LOADED",
  DASHBOARD_FILTERED: "DASHBOARD_FILTERED",
  DOWNLOAD_REPORT: "DOWNLOAD_REPORT",
  SELECT_SETTING: "SELECT_SETTING",
  GATEWAY_POC_UPDATE: "GATEWAY_POC_UPDATE",
  THEME_CHANGED: "THEME_CHANGED",
  OPEN_ADD_PHONE_NUMBER: "OPEN_ADD_PHONE_NUMBER",
  OPEN_UPDATE_PHONE_NUMBER: "OPEN_UPDATE_PHONE_NUMBER",
  SAVE_PHONE_NUMBER: "SAVE_PHONE_NUMBER",
  MESSAGE_CLICKED: "MESSAGE_CLICKED",
  VIEWER_HEADER_NAVIGATION: "VIEWER_HEADER_NAVIGATION",
  ENABLE_NOTIFICATION_FROM_NUDGE: "ENABLE_NOTIFICATION_FROM_NUDGE",
  IGNORE_NOTIFICATION_FROM_NUDGE: "IGNORE_NOTIFICATION_FROM_NUDGE",
  UPDATE_SYSTEM_NOTIFICATION_SETTINGS: "UPDATE_SYSTEM_NOTIFICATION_SETTINGS",
  FORM_RESET: "FORM_RESET",
  FORM_RESET_CANCEL: "FORM_RESET_CANCEL",
  UNSAVED_SETTINGS_DISCARD: "UNSAVED_SETTINGS_DISCARD",
  UNSAVED_SETTINGS_CANCEL: "UNSAVED_SETTINGS_CANCEL",
  SHOW_SYNC_DETAILS: "SHOW_SYNC_DETAILS",
  CLOSE_SYNC_DETAILS: "CLOSE_SYNC_DETAILS",
  SEARCH_PATIENT_FOR_MERGE: "SEARCH_PATIENT_FOR_MERGE",
  CLEAR_SEARCH_PATIENT_FOR_MERGE: "CLEAR_SEARCH_PATIENT_FOR_MERGE",
  SELECT_PATIENT_FOR_MERGE: "SELECT_PATIENT_FOR_MERGE",
  DESELECT_PATIENT_FOR_MERGE: "DESELECT_PATIENT_FOR_MERGE",
  READ_MORE_REPORT_CLICKED: "READ_MORE_REPORT_CLICKED",
  COLLAPSE_STUDIES_SIDEBAR: "COLLAPSE_STUDIES_SIDEBAR",
  EDIT_REPORT_CLICKED: "EDIT_REPORT_CLICKED",
  EDIT_REPORT_CANCELLED: "EDIT_REPORT_CANCELLED",
  EXIT_VIEWER: "EXIT_VIEWER",
  FORMS_ADDED_OR_REMOVED: "FORMS_ADDED_OR_REMOVED",
  LLM_ACTION: "LLM_ACTION",
  LLM_MODAL_BUTTONS: "LLM_MODAL_BUTTONS",
  ASSISTANT_ACTION: "ASSISTANT_ACTION",
  ASSISTANT_MODAL_BUTTONS: "ASSISTANT_MODAL_BUTTONS",
  ASSISTANT_FEEDBACK: "ASSISTANT_FEEDBACK",
  ASSISTANT_OPEN: "ASSISTANT_OPEN",
  ASSISTANT_CHATINPUT_SPEAK: "ASSISTANT_CHATINPUT_SPEAK",
  ASSISTANT_CHATINPUT_CLEAR: "ASSISTANT_CHATINPUT_CLEAR",
  ASSISTANT_PROMPT_MODAL_OPEN: "ASSISTANT_PROMPT_MODAL_OPEN",
  ASSISTANT_PROMPT_SELECTED: "ASSISTANT_PROMPT_SELECTED",
  ASSISTANT_CHATINPUT_SEND_BUTTON: "ASSISTANT_CHATINPUT_SEND_BUTTON",
  ASSISTANT_CHATINPUT_SEND_ENTER: "ASSISTANT_CHATINPUT_SEND_ENTER",
  ASSISTANT_CHATINPUT_STOP_RECORDING: "ASSISTANT_CHATINPUT_STOP_RECORDING",
  //LC Tracking Actions
  LC_FILTER_APPLIED: "LC_FILTER_APPLIED",
  LC_SEARCH_PATIENT_FILTER: "LC_SEARCH_PATIENT_FILTER",
  COPY_PATIENT_ID: "COPY_PATIENT_ID",
  VIEWER_IMAGE_SWITCHED: "VIEWER_IMAGE_SWITCHED",
  VIEWER_IMAGE_AI_TOGGLED: "VIEWER_IMAGE_AI_TOGGLED",
  NLP_ERROR_CLICK: "NLP_ERROR_CLICK",
  REVIEW_REJECT_CLICK: "REVIEW_REJECT_CLICK",
  REVIEW_ACCEPT_CLICK: "REVIEW_ACCEPT_CLICK",
  EXPORT_DATA_SUBMIT: "EXPORT_DATA_SUBMIT",
  EXPORT_DATA_CANCEL: "EXPORT_DATA_CANCEL",
  DISK_SPACE_ALERT_CLICKED: "DISK_SPACE_ALERT_CLICKED",
  DISK_SPACE_ALERT_DISMISSED: "DISK_SPACE_ALERT_DISMISSED",
  DISK_SPACE_ALERT_MANAGE_STORAGE_CLICKED: "DISK_SPACE_ALERT_MANAGE_STORAGE_CLICKED",
  LICENSE_ALERT_DISMISSED: "LICENSE_ALERT_DISMISSED",
  LICENSE_ALERT_VIEW_DETAILS_CLICKED: "LICENSE_ALERT_VIEW_DETAILS_CLICKED",
  LICENSE_ALERT_CLICKED: "LICENSE_ALERT_CLICKED",
  MWL_RETRY: "MWL_RETRY",
  LOGIN_SOURCE: "LOGIN_SOURCE",
  OPEN_BULK_ACTIONS: "open_bulk_actions",
  CREATE_LETTER_TEMPLATE: "CREATE_LETTER_TEMPLATE",
  EDIT_LETTER_TEMPLATE: "EDIT_LETTER_TEMPLATE",
  SAVE_LETTER_TEMPLATE: "SAVE_LETTER_TEMPLATE",
  GENERATE_LETTER: "GENERATE_LETTER",
  PRINT_LETTER: "PRINT_LETTER",
  EMAIL_LETTER: "EMAIL_LETTER",
  EDIT_LETTER: "EDIT_LETTER",
  SELECT_REGION_LANDING: "SELECT_REGION_LANDING",
  JOIN_WORKSPACE_LANDING: "JOIN_WORKSPACE_LANDING",
  LOGIN_LANDING: "LOGIN_LANDING",
  ABOUT_US_LANDING: "ABOUT_US_LANDING",
  SEND_REQUEST_TO_JOIN: "SEND_REQUEST_TO_JOIN",
  CANCEL_REQUEST_TO_JOIN: "CANCEL_REQUEST_TO_JOIN",
  JOIN_ANOTHER_WORKSPACE: "JOIN_ANOTHER_WORKSPACE",
  JOIN_WORKSPACE_LOGGEDIN_USER: "JOIN_WORKSPACE_LOGGEDIN_USER",
  JOIN_WORKSPACE_QR_SCAN: "JOIN_WORKSPACE_QR_SCAN",
  JOIN_WORKSPACE_TOKEN_VALIDATE: "JOIN_WORKSPACE_TOKEN_VALIDATE",
  LOGIN_AFTER_WORKSPACE_VALIDATION: "LOGIN_AFTER_WORKSPACE_VALIDATION",
  REGISTER_AFTER_WORKSPACE_VALIDATION: "REGISTER_AFTER_WORKSPACE_VALIDATION",
  QSYNC_INITIATED: "QSYNC_INITIATED",
  // SearchFilters
  FILTER_PANEL_OPENED: "FILTER_PANEL_OPENED",
  FILTER_PANEL_CLOSED: "FILTER_PANEL_CLOSED",
  FILTER_SAVE_OPENED: "FILTER_SAVE_OPENED",
  FILTER_CLEARED: "FILTER_CLEARED",
  FILTER_DATE_RANGE_SET: "FILTER_DATE_RANGE_SET",
  FILTER_QUICK_DATE_SELECTED: "FILTER_QUICK_DATE_SELECTED",
  FILTER_STATUS_SELECTED: "FILTER_STATUS_SELECTED",
  FILTER_ASSIGNEE_SELECTED: "FILTER_ASSIGNEE_SELECTED",
  FILTER_WORKSPACE_SELECTED: "FILTER_WORKSPACE_SELECTED",
  FILTER_FINDINGS_SELECTED: "FILTER_FINDINGS_SELECTED",
  FILTER_TAG_SELECTED: "FILTER_TAG_SELECTED",
  FILTER_REPORT_STATUS_SELECTED: "FILTER_REPORT_STATUS_SELECTED",
  FILTER_CUSTOM_FIELD_SET: "FILTER_CUSTOM_FIELD_SET",
  FILTER_DELETE_OPENED: "FILTER_DELETE_OPENED",
  FILTER_DELETE_CANCELLED: "FILTER_DELETE_CANCELLED",
  MOBILE_SEARCH_CLOSED: "MOBILE_SEARCH_CLOSED",
  FILTER_LABEL_SELECTED: "FILTER_LABEL_SELECTED",
  TASK_LABEL_SELECTED: "TASK_LABEL_SELECTED",
  // Menubar
  LOGOUT_MODAL_OPENED: "LOGOUT_MODAL_OPENED",
  LOGO_CLICKED: "LOGO_CLICKED",
  NAV_TAB_CLICKED: "NAV_TAB_CLICKED",
  ADD_DROPDOWN_OPENED: "ADD_DROPDOWN_OPENED",
  SWIFT_FILTER_TOGGLED: "SWIFT_FILTER_TOGGLED",
  GATEWAY_INDICATOR_CLICKED: "GATEWAY_INDICATOR_CLICKED",
  GATEWAY_MORE_INFO_CLICKED: "GATEWAY_MORE_INFO_CLICKED",
  LICENSE_ACTIVATED_VIEW_DETAILS: "LICENSE_ACTIVATED_VIEW_DETAILS",
  PRODUCT_TOUR_OPENED: "PRODUCT_TOUR_OPENED",
  PROFILE_DROPDOWN_OPENED: "PROFILE_DROPDOWN_OPENED",
  MOBILE_SEARCH_OPENED: "MOBILE_SEARCH_OPENED",
  GET_FULL_ACCESS_CLICKED: "GET_FULL_ACCESS_CLICKED",
  GET_FULL_ACCESS_DISMISSED: "GET_FULL_ACCESS_DISMISSED",
  GET_FULL_ACCESS_SIGN_IN: "GET_FULL_ACCESS_SIGN_IN",
  // DicomUpload
  DICOM_UPLOAD_MODAL_CLOSED: "DICOM_UPLOAD_MODAL_CLOSED",
  DICOM_FILES_SELECTED: "DICOM_FILES_SELECTED",
  DICOM_CAMERA_OPENED: "DICOM_CAMERA_OPENED",
  DICOM_GUIDELINES_VIEWED: "DICOM_GUIDELINES_VIEWED",
  DICOM_GUIDELINES_BACK: "DICOM_GUIDELINES_BACK",
  DICOM_CAPTURE_SCAN: "DICOM_CAPTURE_SCAN",
  DICOM_IMAGE_CROPPED: "DICOM_IMAGE_CROPPED",
  DICOM_CROP_CANCELLED: "DICOM_CROP_CANCELLED",
  DICOM_CROP_BACK: "DICOM_CROP_BACK",
  DICOM_SELECT_ALL_FILES: "DICOM_SELECT_ALL_FILES",
  DICOM_FILE_SELECTED: "DICOM_FILE_SELECTED",
  DICOM_FILE_EDIT_OPENED: "DICOM_FILE_EDIT_OPENED",
  DICOM_PATIENT_METADATA_EDITED: "DICOM_PATIENT_METADATA_EDITED",
  DICOM_PATIENT_METADATA_SAVED: "DICOM_PATIENT_METADATA_SAVED",
  DICOM_FILE_EDIT_CANCELLED: "DICOM_FILE_EDIT_CANCELLED",
  DICOM_ADD_MORE_FILES: "DICOM_ADD_MORE_FILES",
  DICOM_UPLOAD_PROGRESS_MINIMIZED: "DICOM_UPLOAD_PROGRESS_MINIMIZED",
  DICOM_UPLOAD_PROGRESS_RESTORED: "DICOM_UPLOAD_PROGRESS_RESTORED",
  DICOM_UPLOAD_RETRY: "DICOM_UPLOAD_RETRY",
  DICOM_UPLOAD_COMPLETE_CLOSED: "DICOM_UPLOAD_COMPLETE_CLOSED",
  DICOM_EDIT_MODAL_CLOSED: "DICOM_EDIT_MODAL_CLOSED",
  // PatientRecords
  PATIENT_RECORDS_SECTION_TOGGLED: "PATIENT_RECORDS_SECTION_TOGGLED",
  PATIENT_RECORDS_ITEM_OPENED: "PATIENT_RECORDS_ITEM_OPENED",
  EMR_SYNC_TRIGGERED: "EMR_SYNC_TRIGGERED",
  EMR_FIELD_COPIED: "EMR_FIELD_COPIED",
  EMR_IDENTIFIERS_EXPANDED: "EMR_IDENTIFIERS_EXPANDED",
  EMR_ROW_EXPANDED: "EMR_ROW_EXPANDED",
  APPOINTMENT_FILTER_PANEL_OPENED: "APPOINTMENT_FILTER_PANEL_OPENED",
  APPOINTMENT_TASK_CREATED: "APPOINTMENT_TASK_CREATED",
  APPOINTMENT_DETAIL_OPENED: "APPOINTMENT_DETAIL_OPENED",
  APPOINTMENT_STATUS_FILTER_SET: "APPOINTMENT_STATUS_FILTER_SET",
  APPOINTMENT_PRACTITIONER_FILTER_SET: "APPOINTMENT_PRACTITIONER_FILTER_SET",
  APPOINTMENT_LOCATION_FILTER_SET: "APPOINTMENT_LOCATION_FILTER_SET",
  APPOINTMENT_DATE_FILTER_SET: "APPOINTMENT_DATE_FILTER_SET",
  APPOINTMENT_FILTERS_RESET: "APPOINTMENT_FILTERS_RESET",
  APPOINTMENT_FILTERS_APPLIED: "APPOINTMENT_FILTERS_APPLIED",
  ENCOUNTER_DATE_FILTER_SET: "ENCOUNTER_DATE_FILTER_SET",
  ENCOUNTER_STATUS_FILTER_SET: "ENCOUNTER_STATUS_FILTER_SET",
  ENCOUNTER_DETAIL_OPENED: "ENCOUNTER_DETAIL_OPENED",
  MEDICAL_REPORT_MODAL_CLOSED: "MEDICAL_REPORT_MODAL_CLOSED",
  MEDICAL_REPORT_PRINTED: "MEDICAL_REPORT_PRINTED",
  MEDICAL_REPORT_COPIED: "MEDICAL_REPORT_COPIED",
  // ChatMessageTypes
  VIEWER_OPENED: "VIEWER_OPENED",
  AI_REPORT_OPENED: "AI_REPORT_OPENED",
  FORM_SECTION_TOGGLED: "FORM_SECTION_TOGGLED",
  NOTE_EXPANDED: "NOTE_EXPANDED",
  MEDIA_VIEWER_OPENED: "MEDIA_VIEWER_OPENED",
  RADIOLOGY_REPORT_EXPANDED: "RADIOLOGY_REPORT_EXPANDED",
  RADIOLOGY_REPORT_STUDY_OPENED: "RADIOLOGY_REPORT_STUDY_OPENED",
  RADIOLOGY_REPORT_STUDY_LINKED: "RADIOLOGY_REPORT_STUDY_LINKED",
  RADIOLOGY_REPORT_PRINTED: "RADIOLOGY_REPORT_PRINTED",
  RADIOLOGY_REPORT_COPIED: "RADIOLOGY_REPORT_COPIED",
  RADIOLOGY_REPORT_VERSION_SWITCHED: "RADIOLOGY_REPORT_VERSION_SWITCHED",
  RADIOLOGY_REPORT_TAG_APPLIED: "RADIOLOGY_REPORT_TAG_APPLIED",
  RADIOLOGY_REPORT_SHARED: "RADIOLOGY_REPORT_SHARED",
  LETTER_EXPANDED: "LETTER_EXPANDED",
  // AdminViewBtn + SelectWorkspace
  SITE_ADMIN_OPENED: "SITE_ADMIN_OPENED",
  WORKSPACE_DROPDOWN_OPENED: "WORKSPACE_DROPDOWN_OPENED",
  WORKSPACE_SELECTED: "WORKSPACE_SELECTED",
  // GatewayDropdown
  GATEWAY_EDIT_OPENED: "GATEWAY_EDIT_OPENED",
  GATEWAY_EDIT_CANCELLED: "GATEWAY_EDIT_CANCELLED",
  GATEWAY_POC_FIELD_EDITED: "GATEWAY_POC_FIELD_EDITED",
  GATEWAY_EDIT_CONTACT_OPENED: "GATEWAY_EDIT_CONTACT_OPENED",
  GATEWAY_EDIT_CONTACT_CANCELLED: "GATEWAY_EDIT_CONTACT_CANCELLED",
  // SettingsMenu
  SETTINGS_CLOSED: "SETTINGS_CLOSED",
  // TermsAndConditionsModal
  TERMS_MODAL_CLOSED: "TERMS_MODAL_CLOSED",
  TERMS_CONFIRM_TOGGLED: "TERMS_CONFIRM_TOGGLED",
  TERMS_LINK_CLICKED: "TERMS_LINK_CLICKED",
  PRIVACY_POLICY_CLICKED: "PRIVACY_POLICY_CLICKED",
  TERMS_DISAGREED: "TERMS_DISAGREED",
  TERMS_AGREED: "TERMS_AGREED",
  TERMS_LOGOUT_CONFIRMED: "TERMS_LOGOUT_CONFIRMED",
  TERMS_LOGOUT_CANCELLED: "TERMS_LOGOUT_CANCELLED",
  // WorklistHeader
  WORKLIST_COLLAPSED: "WORKLIST_COLLAPSED",
  WORKLIST_MAXIMIZED: "WORKLIST_MAXIMIZED",
  WORKLIST_MINIMIZED: "WORKLIST_MINIMIZED",
  WORKLIST_EXPANDED: "WORKLIST_EXPANDED",
  WORKLIST_REFRESHED: "WORKLIST_REFRESHED",
  LC_DASHBOARD_CLICKED: "LC_DASHBOARD_CLICKED",
  LC_QTRACK_LINK_CLICKED: "LC_QTRACK_LINK_CLICKED",
  UNREAD_MESSAGES_FILTER_TOGGLED: "UNREAD_MESSAGES_FILTER_TOGGLED",
  WORKLIST_SORT_TYPE_CHANGED: "WORKLIST_SORT_TYPE_CHANGED",
  WORKLIST_SORT_ORDER_CHANGED: "WORKLIST_SORT_ORDER_CHANGED",
  // LCAccessFilters
  LC_FILTER_SCROLL: "LC_FILTER_SCROLL",
  LC_FILTER_OVERFLOW_OPENED: "LC_FILTER_OVERFLOW_OPENED",
  LC_FILTER_OVERFLOW_CLOSED: "LC_FILTER_OVERFLOW_CLOSED",
  LC_FILTER_CLEARED: "LC_FILTER_CLEARED",
  LC_FILTER_SET_DEFAULT: "LC_FILTER_SET_DEFAULT",
  // QuickAccessFilters
  SWIFT_REPORTING_OPENED: "SWIFT_REPORTING_OPENED",
  SWIFT_REPORTING_DISMISSED: "SWIFT_REPORTING_DISMISSED",
  FILTER_OVERFLOW_OPENED: "FILTER_OVERFLOW_OPENED",
  FILTER_OVERFLOW_CLOSED: "FILTER_OVERFLOW_CLOSED",
  QUICK_ACCESS_FILTER_APPLIED: "QUICK_ACCESS_FILTER_APPLIED",
  QUICK_ACCESS_FILTER_CLEARED: "QUICK_ACCESS_FILTER_CLEARED",
  QUICK_ACCESS_FILTER_OVERFLOW_OPENED: "QUICK_ACCESS_FILTER_OVERFLOW_OPENED",
  QUICK_ACCESS_FILTER_OVERFLOW_CLOSED: "QUICK_ACCESS_FILTER_OVERFLOW_CLOSED",
  REPORTING_INFO_MODAL_CLOSED: "REPORTING_INFO_MODAL_CLOSED",
  REPORTING_INFO_APPLY_DEFAULT: "REPORTING_INFO_APPLY_DEFAULT",
  REPORTING_INFO_CUSTOMIZE: "REPORTING_INFO_CUSTOMIZE",
  // Worklist
  BULK_PATIENT_SELECTED: "BULK_PATIENT_SELECTED",
  BULK_ASSIGNEE_DROPDOWN_OPENED: "BULK_ASSIGNEE_DROPDOWN_OPENED",
  BULK_ASSIGNED: "BULK_ASSIGNED",
  BULK_ADD_FIELD_OPENED: "BULK_ADD_FIELD_OPENED",
  BULK_FIELD_VALUE_CHANGED: "BULK_FIELD_VALUE_CHANGED",
  BULK_FIELD_REMOVED: "BULK_FIELD_REMOVED",
  BULK_FIELDS_UPDATED: "BULK_FIELDS_UPDATED",
  BULK_FIELD_EDIT_OPENED: "BULK_FIELD_EDIT_OPENED",
  BULK_FIELD_EDIT_SAVED: "BULK_FIELD_EDIT_SAVED",
  BULK_FIELD_EDIT_CANCELLED: "BULK_FIELD_EDIT_CANCELLED",
  // PatientChannel
  PATIENT_CHANNEL_TAB_SWITCHED: "PATIENT_CHANNEL_TAB_SWITCHED",
  TOGGLE_VIEW_SWITCHED: "TOGGLE_VIEW_SWITCHED",
  PATIENT_TAGS_PANEL_TOGGLED: "PATIENT_TAGS_PANEL_TOGGLED",
  PATIENT_CHANNEL_BACK: "PATIENT_CHANNEL_BACK",
  PATIENT_NAME_EDIT_OPENED: "PATIENT_NAME_EDIT_OPENED",
  PATIENT_NAVIGATION: "PATIENT_NAVIGATION",
  PATIENT_TAG_CLICKED: "PATIENT_TAG_CLICKED",
  EMERGENCY_MODAL_OPENED: "EMERGENCY_MODAL_OPENED",
  // Chat
  MESSAGE_STARRED: "MESSAGE_STARRED",
  AIRA_MODAL_OPENED: "AIRA_MODAL_OPENED",
  REPORT_COMPOSER_OPENED: "REPORT_COMPOSER_OPENED",
  REPORT_COMPOSER_CLOSED: "REPORT_COMPOSER_CLOSED",
  REPORT_PDF_UPLOADED: "REPORT_PDF_UPLOADED",
  REPORT_CSV_EXPANDED: "REPORT_CSV_EXPANDED",
  NOTES_PANEL_OPENED: "NOTES_PANEL_OPENED",
  NOTES_PANEL_CLOSED: "NOTES_PANEL_CLOSED",
  // qTrack patient SMS
  SMS_PANEL_OPENED: "SMS_PANEL_OPENED",
  SMS_PANEL_CLOSED: "SMS_PANEL_CLOSED",
  SMS_SEND_INITIATED: "SMS_SEND_INITIATED",
  SMS_SENT: "SMS_SENT",
  SMS_SEND_FAILED: "SMS_SEND_FAILED",
  SMS_RETRY: "SMS_RETRY",
  SMS_TEMPLATE_SELECTED: "SMS_TEMPLATE_SELECTED",
  SMS_TEMPLATE_CREATED: "SMS_TEMPLATE_CREATED",
  SMS_TEMPLATE_SAVED: "SMS_TEMPLATE_SAVED",
  SMS_TEMPLATE_DELETED: "SMS_TEMPLATE_DELETED",
  FORM_SELECTOR_CLOSED: "FORM_SELECTOR_CLOSED",
  SUGGESTED_ACTION_TRIGGERED: "SUGGESTED_ACTION_TRIGGERED",
  SUGGESTED_ACTION_EXECUTED: "SUGGESTED_ACTION_EXECUTED",
  // Sidebar+ReportEditor
  REPORT_TEMPLATE_PICKER_OPENED: "REPORT_TEMPLATE_PICKER_OPENED",
  REPORT_TEMPLATE_APPLIED: "REPORT_TEMPLATE_APPLIED",
  // PatientTags
  PATIENT_TAG_FIELD_SELECTED: "PATIENT_TAG_FIELD_SELECTED",
  PATIENT_TAGS_EDIT_OPENED: "PATIENT_TAGS_EDIT_OPENED",
  PATIENT_TAGS_SAVED: "PATIENT_TAGS_SAVED",
  PATIENT_TAGS_DISCARDED: "PATIENT_TAGS_DISCARDED",
  PATIENT_TAG_VALUE_CHANGED: "PATIENT_TAG_VALUE_CHANGED",
  PATIENT_TAG_EDIT_OPENED: "PATIENT_TAG_EDIT_OPENED",
  PATIENT_TAG_DELETED: "PATIENT_TAG_DELETED",
  PATIENT_TAG_REVERTED: "PATIENT_TAG_REVERTED",
  PATIENT_TAGS_LIST_TOGGLED: "PATIENT_TAGS_LIST_TOGGLED",
  PATIENT_TAG_SEARCHED: "PATIENT_TAG_SEARCHED",
  FILTER_FINDINGS_JOIN_CHANGED: "FILTER_FINDINGS_JOIN_CHANGED",
  // SummarySection
  CASE_SNAPSHOT_EXPANDED: "CASE_SNAPSHOT_EXPANDED",
  CASE_SNAPSHOT_COLLAPSED: "CASE_SNAPSHOT_COLLAPSED",
  CASE_SNAPSHOT_REGENERATE_RETRY: "CASE_SNAPSHOT_REGENERATE_RETRY",
  CASE_SNAPSHOT_REGENERATED: "CASE_SNAPSHOT_REGENERATED",
  CASE_SNAPSHOT_VIEW_OPENED: "CASE_SNAPSHOT_VIEW_OPENED",
  REMINDERS_LIST_OPENED: "REMINDERS_LIST_OPENED",
  REMINDER_CREATE_OPENED: "REMINDER_CREATE_OPENED",
  REMINDER_FORM_DISMISSED: "REMINDER_FORM_DISMISSED",
  // PatientStudies
  PATIENT_STUDIES_TAB_SWITCHED: "PATIENT_STUDIES_TAB_SWITCHED",
  REPORT_COLLAPSED: "REPORT_COLLAPSED",
  // PatientSharing+InviteUsers
  PATIENT_REMOVE_ACCESS_OPENED: "PATIENT_REMOVE_ACCESS_OPENED",
  PATIENT_REMOVE_ACCESS_CANCELLED: "PATIENT_REMOVE_ACCESS_CANCELLED",
  PATIENT_SHARE_CLOSED: "PATIENT_SHARE_CLOSED",
  PATIENT_ACCESS_REVOKED: "PATIENT_ACCESS_REVOKED",
  INVITE_USERS_SEARCHED: "INVITE_USERS_SEARCHED",
  INVITE_USER_ADDED: "INVITE_USER_ADDED",
  INVITE_USER_REMOVED: "INVITE_USER_REMOVED",
  INVITE_USERS_DROPDOWN_CLOSED: "INVITE_USERS_DROPDOWN_CLOSED",
  // FormSelector + DynamicForm
  FORMS_MANAGE_CLICKED: "FORMS_MANAGE_CLICKED",
  FORM_RESET_INITIATED: "FORM_RESET_INITIATED",
  FORM_FIELD_CHANGED: "FORM_FIELD_CHANGED",
  // LetterTemplates
  LETTER_TEMPLATE_SELECTED: "LETTER_TEMPLATE_SELECTED",
  LETTER_TEMPLATE_EDITED: "LETTER_TEMPLATE_EDITED",
  LETTER_TEMPLATE_EDIT_DISCARDED: "LETTER_TEMPLATE_EDIT_DISCARDED",
  LETTER_TEMPLATE_SEARCHED: "LETTER_TEMPLATE_SEARCHED",
  LETTER_TEMPLATE_DELETED: "LETTER_TEMPLATE_DELETED",
  REPORT_SELECTED_FOR_LETTER: "REPORT_SELECTED_FOR_LETTER",
  // EmergencyAlert
  EMERGENCY_REASON_SELECTED: "EMERGENCY_REASON_SELECTED",
  EMERGENCY_TIMER_CANCELLED: "EMERGENCY_TIMER_CANCELLED",
  // MatchingPatient
  MERGE_PRIMARY_FIELD_SELECTED: "MERGE_PRIMARY_FIELD_SELECTED",
  MERGE_PATIENT_DISMISSED: "MERGE_PATIENT_DISMISSED",
  // AddEditPatient + AddPhoneNumber
  PATIENT_FORM_FIELD_CHANGED: "PATIENT_FORM_FIELD_CHANGED",
  ADD_PHONE_NUMBER_SKIPPED: "ADD_PHONE_NUMBER_SKIPPED",
  ADD_PHONE_NUMBER_DISMISSED: "ADD_PHONE_NUMBER_DISMISSED",
  // Attachments + AudioRecorder
  AUDIO_RECORDER_OPENED: "AUDIO_RECORDER_OPENED",
  AUDIO_RECORDING_STARTED: "AUDIO_RECORDING_STARTED",
  AUDIO_RECORDING_STOPPED: "AUDIO_RECORDING_STOPPED",
  AUDIO_RECORDING_PAUSED: "AUDIO_RECORDING_PAUSED",
  AUDIO_RECORDING_DISCARD_OPENED: "AUDIO_RECORDING_DISCARD_OPENED",
  AUDIO_RECORDING_KEPT: "AUDIO_RECORDING_KEPT",
  AUDIO_RECORDING_DISCARDED: "AUDIO_RECORDING_DISCARDED",
  AUDIO_PLAYBACK_STARTED: "AUDIO_PLAYBACK_STARTED",
  AUDIO_PLAYBACK_PAUSED: "AUDIO_PLAYBACK_PAUSED",
  AUDIO_PLAYBACK_SEEKED: "AUDIO_PLAYBACK_SEEKED",
  AUDIO_RECORDER_CLOSED: "AUDIO_RECORDER_CLOSED",
  AUDIO_TAG_SELECTED: "AUDIO_TAG_SELECTED",
  LETTER_EDITOR_CLOSED: "LETTER_EDITOR_CLOSED",
  LETTER_AIRA_QUERIED: "LETTER_AIRA_QUERIED",
  STARRED_MESSAGE_CLICKED: "STARRED_MESSAGE_CLICKED",
  STARRED_MESSAGE_SCROLLED: "STARRED_MESSAGE_SCROLLED",
  REMINDER_FIELD_CHANGED: "REMINDER_FIELD_CHANGED",
  REMINDER_SAVED: "REMINDER_SAVED",
  REMINDER_UPDATED: "REMINDER_UPDATED",
  REMINDER_EDIT_OPENED: "REMINDER_EDIT_OPENED",
  REMINDER_RESOLVED: "REMINDER_RESOLVED",
  REMINDER_LINK_RECORDS_OPENED: "REMINDER_LINK_RECORDS_OPENED",
  REPORT_PDF_PARSED: "REPORT_PDF_PARSED",
  VIEWER_REPORT_PREVIEW_TOGGLED: "VIEWER_REPORT_PREVIEW_TOGGLED",
  // MediaViewer
  MEDIA_VIEWER_CLOSED: "MEDIA_VIEWER_CLOSED",
  // LKWCalculator
  LKW_CALCULATOR_DATE_SET: "LKW_CALCULATOR_DATE_SET",
  LKW_CALCULATOR_CANCELLED: "LKW_CALCULATOR_CANCELLED",
  // DynamicViewer
  VIEWER_STUDY_NAVIGATION: "VIEWER_STUDY_NAVIGATION",
  //SupportWidget
  SUPPORT_WIDGET_TICKET_CREATED: "SUPPORT_WIDGET_TICKET_CREATED",
  SUPPORT_WIDGET_ERROR: "SUPPORT_WIDGET_ERROR",
  SUPPORT_WIDGET_MINIMIZED: "SUPPORT_WIDGET_MINIMIZED",
  SUPPORT_WIDGET_ATTACHMENT_PREVIEWED: "SUPPORT_WIDGET_ATTACHMENT_PREVIEWED",
  SUPPORT_WIDGET_ATTACHMENT_DOWNLOADED: "SUPPORT_WIDGET_ATTACHMENT_DOWNLOADED",
  SWITCH_TO_OLD_VIEWER: "SWITCH_TO_OLD_VIEWER",
  SWITCH_TO_NEW_VIEWER: "SWITCH_TO_NEW_VIEWER",
  DISMISS_VIEWR_TOGGLE: "DISMISS_VIEWR_TOGGLE",
  OK_VIEWR_TOGGLE: "OK_VIEWR_TOGGLE",
  VIEWER_V2_SERIES_CHANGE: "VIEWER_V2_SERIES_CHANGE",
  DISCORDANCE_OVERLAY_TOGGLE: "DISCORDANCE_OVERLAY_TOGGLE",
  // PatientMerging
  MERGE_REVIEW_OPENED: "MERGE_REVIEW_OPENED",
  MERGE_REVIEW_CANCELLED: "MERGE_REVIEW_CANCELLED",
  MERGE_CONFLICT_RESOLVED: "MERGE_CONFLICT_RESOLVED",
  MERGE_UNIQUE_TAG_TOGGLED: "MERGE_UNIQUE_TAG_TOGGLED",
  MERGE_REVIEW_CONFIRMED: "MERGE_REVIEW_CONFIRMED",
  MERGE_RETRY_CLICKED: "MERGE_RETRY_CLICKED",
  MRN_UPDATE_ACKNOWLEDGED: "MRN_UPDATE_ACKNOWLEDGED",
  MERGED_PATIENT_NAVIGATED: "MERGED_PATIENT_NAVIGATED",
  // ACR Events
  ACR_LOGIN_INITIATED: "ACR_LOGIN_INITIATED",
  // Bidirectional Sync
  BIDIRECTIONAL_SYNC_REFRESHED: "BIDIRECTIONAL_SYNC_REFRESHED",
  // Create New Encounter
  CREATE_ENCOUNTER_REVIEW_CLICKED: "CREATE_ENCOUNTER_REVIEW_CLICKED",
  CREATE_ENCOUNTER_SUBMIT_ATTEMPTED: "CREATE_ENCOUNTER_SUBMIT_ATTEMPTED",
  CREATE_ENCOUNTER_SUBMIT_SUCCESS: "CREATE_ENCOUNTER_SUBMIT_SUCCESS",
  CREATE_ENCOUNTER_SUBMIT_FAILED: "CREATE_ENCOUNTER_SUBMIT_FAILED",
  CREATE_ENCOUNTER_LETTER_ATTACHED: "CREATE_ENCOUNTER_LETTER_ATTACHED",
  CREATE_ENCOUNTER_LETTER_ATTACH_FAILED: "CREATE_ENCOUNTER_LETTER_ATTACH_FAILED"
};
var MIXPANEL_PAGES = {
  PATIENTS: "PATIENTS",
  VIEWER: "VIEWER",
  VIEWER_V2: "VIEWER_V2",
  PATIENT_CHANNEL: "PATIENT_CHANNEL",
  LUNGCANCER: "LUNGCANCER"
};
var MIXPANEL_OTHER_EVENTS = {
  PAGE_EXIT: "Page Exit"
};
export { MIXPANEL_EVENTS, MIXPANEL_OTHER_EVENTS, MIXPANEL_PAGES };